@switch (libType === BUTTON_TYPE.COMPACT ? BUTTON_TYPE.BASIC : libType) {
    @case (BUTTON_TYPE.BASIC) {
        <button mat-button
                disableRipple="true"
                class="tal-basic-button lib-button-padding"
                [class.tal-compact-button]="libType === BUTTON_TYPE.COMPACT"
                [ngClass]="{
                    'bg-primary border-primary primary-button': libSubType === BUTTON_SUB_TYPE.PRIMARY && showBorder,
                    'bg-gradient text-white': libSubType === BUTTON_SUB_TYPE.GRADIENT && showBorder,
                    'text-primary bg-white border-primary-light primary-button-light secondary-button': libSubType ===
                    BUTTON_SUB_TYPE.SECONDARY && showBorder,
                    'text-white bg-danger-primary danger-button': libSubType === BUTTON_SUB_TYPE.DANGER && showBorder,
                    'text-danger border-danger-light danger-button-secondary': libSubType === BUTTON_SUB_TYPE.DANGER_SECONDARY &&
                    showBorder,
                    'warning-button': libSubType === BUTTON_SUB_TYPE.WARNING && showBorder,
                    'success-button': libSubType === BUTTON_SUB_TYPE.SUCCESS && showBorder,
                    'tal-light-primary-button': libSubType === BUTTON_SUB_TYPE.LIGHT,
                    'cursor-not-allowed': disabled || spinner
                    }"
                [disabled]="disabled || spinner"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="buttonRef"></ng-template>
        </button>
    }
    @case (BUTTON_TYPE.LARGE) {
        <button mat-button
                disableRipple="true"
                class="tal-large-button lib-button-padding"
                [ngClass]="{
                    'text-white bg-primary border-primary primary-button': libSubType === BUTTON_SUB_TYPE.PRIMARY,
                    'bg-gradient text-white': libSubType === BUTTON_SUB_TYPE.GRADIENT && showBorder,
                    'text-primary bg-white border-primary-light primary-button-light': libSubType ===
                    BUTTON_SUB_TYPE.SECONDARY,
                    'text-white bg-danger-primary danger-button': libSubType === BUTTON_SUB_TYPE.DANGER,
                    'text-danger border-danger-light danger-button-secondary': libSubType === BUTTON_SUB_TYPE.DANGER_SECONDARY,
                    'warning-button': libSubType === BUTTON_SUB_TYPE.WARNING,
                    'success-button': libSubType === BUTTON_SUB_TYPE.SUCCESS,
                    'tal-light-primary-button': libSubType === BUTTON_SUB_TYPE.LIGHT
                    }"
                [matTooltip]="tooltipText"
                [matTooltipClass]="matTooltipClass"
                [matTooltipPosition]="matTooltipPosition"
                [attr.aria-label]="ariaLabel"
                [disabled]="disabled || spinner"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="buttonRef"></ng-template>
        </button>
    }
    @case (BUTTON_TYPE.ROUNDED) {
        <button mat-button
                disableRipple="true"
                class="tal-rounded-button lib-button-padding"
                [ngClass]="{
                    'text-white bg-primary border-primary primary-button': libSubType === BUTTON_SUB_TYPE.PRIMARY,
                    'bg-gradient text-white': libSubType === BUTTON_SUB_TYPE.GRADIENT && showBorder,
                    'text-primary bg-white border-primary-light primary-button-light': libSubType ===
                    BUTTON_SUB_TYPE.SECONDARY,
                    'text-white bg-danger-primary danger-button': libSubType === BUTTON_SUB_TYPE.DANGER,
                    'text-danger border-danger-light danger-button-secondary': libSubType === BUTTON_SUB_TYPE.DANGER_SECONDARY,
                    'warning-button': libSubType === BUTTON_SUB_TYPE.WARNING,
                    'success-button': libSubType === BUTTON_SUB_TYPE.SUCCESS,
                    'tal-light-primary-button': libSubType === BUTTON_SUB_TYPE.LIGHT,
                    'tal-rounded-outlined-button': libSubType === BUTTON_SUB_TYPE.OUTLINED,
                    'tal-rounded-danger-outlined-button': libSubType === BUTTON_SUB_TYPE.DANGER_OUTLINED,
                    'tal-rounded-text-button': libSubType === BUTTON_SUB_TYPE.TEXT
                    }"
                [disabled]="disabled || spinner"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="buttonRef"></ng-template>
        </button>
    }
    @case (BUTTON_TYPE.ICON) {
        <button class="tal-icon-button lib-button-padding"
                [matTooltip]="tooltipText"
                [matTooltipClass]="matTooltipClass"
                [matTooltipPosition]="matTooltipPosition"
                [ngClass]="{
                    'text-white bg-primary border-primary primary-button': libSubType === BUTTON_SUB_TYPE.PRIMARY,
                    'text-primary bg-white border-primary-light primary-button-light': libSubType ===
                    BUTTON_SUB_TYPE.SECONDARY,
                    'bg-white border-primary-light primary-button-light': libSubType === BUTTON_SUB_TYPE.DEFAULT,
                    'tal-light-primary-button': libSubType === BUTTON_SUB_TYPE.LIGHT,
                    'borderless-danger-icon-button': libSubType === BUTTON_SUB_TYPE.DANGER_SECONDARY,
                    'cursor-not-allowed': disabled || spinner
                    }"
                [disabled]="disabled || spinner"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="iconButtonRef"></ng-template>
        </button>
    }
    @case (BUTTON_TYPE.MEDIUM_ICON) {
        <button class="tal-icon-medium-button"
                [matTooltip]="tooltipText"
                [matTooltipClass]="matTooltipClass"
                [matTooltipPosition]="matTooltipPosition"
                [ngClass]="{
                    'text-white bg-primary border-primary primary-button': libSubType === BUTTON_SUB_TYPE.PRIMARY,
                    'text-primary bg-white border-primary-light primary-button-light': libSubType ===
                    BUTTON_SUB_TYPE.SECONDARY,
                    'bg-white border-primary-light primary-button-light': libSubType === BUTTON_SUB_TYPE.DEFAULT,
                    'tal-light-primary-button': libSubType === BUTTON_SUB_TYPE.LIGHT,
                    'borderless-danger-icon-button': libSubType === BUTTON_SUB_TYPE.DANGER_SECONDARY,
                    'cursor-not-allowed': disabled || spinner
                    }"
                [disabled]="disabled || spinner"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="iconButtonRef"></ng-template>
        </button>
    }
    @case (BUTTON_TYPE.SMALL_ICON) {
        <button class="tal-icon-small-button lib-button-padding"
                [attr.aria-label]="ariaLabel || tooltipText"
                [attr.aria-pressed]="ariaPressed()"
                [matTooltip]="tooltipText"
                [matTooltipClass]="matTooltipClass"
                [matTooltipPosition]="matTooltipPosition"
                [ngClass]="{
                    'text-white bg-primary border-primary primary-button': libSubType === BUTTON_SUB_TYPE.PRIMARY,
                    'text-primary bg-white border-primary-light primary-button-light': libSubType ===
                    BUTTON_SUB_TYPE.SECONDARY,
                    'text-danger border-danger-light danger-button-secondary': libSubType === BUTTON_SUB_TYPE.DANGER_SECONDARY,
                    'tal-icon-small-borderless-button': libSubType === BUTTON_SUB_TYPE.DEFAULT && !showBorder,
                    'tal-icon-small-borderless-selected-button': libSubType === BUTTON_SUB_TYPE.DEFAULT && !showBorder && selected
                    }"
                [disabled]="disabled || spinner"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="iconButtonRef"></ng-template>
        </button>
    }
    @case (BUTTON_TYPE.ROUNDED_ICON) {
        <button class="tal-icon-rounded-button"
                type="button"
                [attr.aria-label]="ariaLabel || tooltipText"
                [attr.aria-pressed]="ariaPressed()"
                [matTooltip]="tooltipText"
                [matTooltipClass]="matTooltipClass"
                [matTooltipPosition]="matTooltipPosition"
                [ngClass]="{
                    'text-white bg-primary border-primary primary-button': libSubType === BUTTON_SUB_TYPE.PRIMARY,
                    'text-primary bg-white border-primary-light primary-button-light': libSubType ===
                    BUTTON_SUB_TYPE.SECONDARY,
                    'tal-icon-rounded-default-button': libSubType === BUTTON_SUB_TYPE.DEFAULT && showBorder,
                    'tal-icon-rounded-borderless-button': libSubType === BUTTON_SUB_TYPE.DEFAULT && !showBorder,
                    'tal-icon-rounded-current-color-button': libSubType === BUTTON_SUB_TYPE.CURRENT_COLOR,
                    'borderless-danger-icon-button': libSubType === BUTTON_SUB_TYPE.DANGER_SECONDARY,
                    'cursor-not-allowed': disabled || spinner
                    }"
                [disabled]="disabled || spinner"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="iconButtonRef"></ng-template>
        </button>
    }
    @case (BUTTON_TYPE.LIST_ITEM) {
        <button class="tal-list-item-button"
                type="button"
                [matTooltip]="tooltipText"
                [matTooltipClass]="matTooltipClass"
                [matTooltipPosition]="matTooltipPosition"
                [ngClass]="{
                    'tal-list-item-danger-button': libSubType === BUTTON_SUB_TYPE.DANGER_SECONDARY,
                    'cursor-not-allowed': disabled || spinner
                    }"
                [attr.role]="buttonRole()"
                [attr.aria-checked]="ariaChecked()"
                [disabled]="disabled || spinner"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="buttonRef"></ng-template>
        </button>
    }
    @case (BUTTON_TYPE.CHIP) {
        <button class="tal-chip-button"
                type="button"
                [matTooltip]="tooltipText"
                [matTooltipClass]="matTooltipClass"
                [matTooltipPosition]="matTooltipPosition"
                [ngClass]="{
                    'tal-chip-selected-button': selected,
                    'tal-chip-default-button': !selected,
                    'tal-chip-reaction-button': libChipVariant() === BUTTON_CHIP_VARIANT.REACTION,
                    'tal-chip-reaction-option-button': libChipVariant() === BUTTON_CHIP_VARIANT.REACTION_OPTION,
                    'tal-chip-reaction-more-option-button': libChipVariant() === BUTTON_CHIP_VARIANT.REACTION_MORE_OPTION,
                    'tal-chip-reaction-detail-button': libChipVariant() === BUTTON_CHIP_VARIANT.REACTION_DETAIL,
                    'tal-chip-emoji-category-button': libChipVariant() === BUTTON_CHIP_VARIANT.EMOJI_CATEGORY,
                    'tal-chip-message-action-button': libChipVariant() === BUTTON_CHIP_VARIANT.MESSAGE_ACTION,
                    'tal-chip-message-reaction-button': libChipVariant() === BUTTON_CHIP_VARIANT.MESSAGE_REACTION,
                    'cursor-not-allowed': disabled || spinner
                    }"
                [attr.role]="buttonRole()"
                [attr.aria-label]="ariaLabel"
                [attr.aria-pressed]="ariaHasPopup() ? null : selected"
                [attr.aria-haspopup]="ariaHasPopup()"
                [attr.aria-expanded]="ariaHasPopup() ? ariaExpanded() : null"
                [attr.aria-checked]="ariaChecked()"
                [disabled]="disabled || spinner"
                (click)="onClick($event)">
            <ng-template [ngTemplateOutlet]="buttonRef"></ng-template>
        </button>
    }
    @case (BUTTON_TYPE.FAB) {
        <div class="bg-white rounded-full">
            <button mat-icon-button
                    type="button"
                    [ngClass]="{
                        'text-primary bg-primary-light': libSubType === BUTTON_SUB_TYPE.PRIMARY,
                        'text-primary bg-white-light': libSubType === BUTTON_SUB_TYPE.SECONDARY,
                        'text-warn bg-warning-light': libSubType === BUTTON_SUB_TYPE.WARNING,
                        'text-danger bg-danger-light': libSubType === BUTTON_SUB_TYPE.DANGER,
                        'text-success bg-success-light': libSubType === BUTTON_SUB_TYPE.SUCCESS
                    }"
                    [matTooltip]="tooltipText"
                    [matTooltipClass]="matTooltipClass"
                    [matTooltipPosition]="matTooltipPosition"
                    [disabled]="disabled"
                    (click)="buttonClick.emit($event)">
                <mat-icon class="w-5 h-5 text-xl"
                          [color]="libSubType === BUTTON_SUB_TYPE.PRIMARY ? 'primary' : null"
                          [fontIcon]="iconClass">
                    <!--  TODO: check [fontIcon]="iconClass"-->
                </mat-icon>
            </button>
        </div>
    }
}

<ng-template #buttonRef>
    <div class="flex flex-row justify-center items-center">
        @if (spinner) {
            <mat-icon class="mr-2">
                <mat-spinner diameter="20"></mat-spinner>
            </mat-icon>
        }
        @if (svgUrl) {
            <div class="w-6 h-6 mr-2">
                <img class="w-6 h-6" [src]="svgUrl" alt="">
            </div>
        }
        @if (!spinner && iconClass && iconPosition === BUTTON_ICON_POSITION.BEFORE) {
            <div class="mr-0.5" [ngClass]=iconClass></div>
        }
        <ng-content></ng-content>
        @if (iconClass && iconPosition === BUTTON_ICON_POSITION.AFTER) {
            <div class="ml-0.5" [ngClass]=iconClass></div>
        }
    </div>
</ng-template>

<ng-template #iconButtonRef>
    <div class="flex flex-row justify-center items-center relative">
        <div aria-hidden="true" [ngClass]=iconClass></div>
        @if (spinner) {
            <lib-spinner></lib-spinner>
        }
    </div>
</ng-template>
